<template>
  <div>
    <Modal
      v-model="visible"
      :mask-closable="false"
      title="更新异常记录"
      :footer-hide="true"
      width="640"
      class="my-modal top p-b"
    >
      <div class="update-abnormal">
        <span class="title"
          >系统已成功导入<span class="num">{{ abnormalNumber.successExport }}</span
          >条数据，但检测到存在异常数据<span class="num">{{ abnormalNumber.abnormal }}</span
          >条，系统未存在保单<span class="num">{{ abnormalNumber.noPolicy }}</span>条</span
        >
          <div class="tips">
              <span>1、请下载<a @click="downloadData(1)">异常数据</a>查看异常详情并确认<span class="sign">是否更新系统数据</span></span>
              <span>2、请下载<a @click="downloadData(2)">系统未存在保单数据</a>您可前往 <span class="sign">业务管理——保单管理</span> 新增保单数据</span>
          </div>
      </div>
      <div class="action-buttom">
        <Button type="primary" @click="updateAndgiveUp(1)">更新异常数据</Button>
        <Button class="cancel" @click="updateAndgiveUp(2)">放弃异常数据</Button>
        <Button class="cancel" @click="$refs.dataConfirm.open()">暂不处理异常数据</Button>
      </div>
    </Modal>

    <!-- 暂不处理数据确认框 -->
    <handle-data-confirm ref="dataConfirm" @confirmHandleData='confirmHandleData'></handle-data-confirm>
  </div>
</template>

<script>
import handleDataConfirm from './handleDataConfirm';
export default {
  components:{
    handleDataConfirm
  },
  props:['getInsureList'],
  data() {
    return {
      visible: false,
      abnormalNumber:{}
    };
  },

  methods: {
    open() {
      this.queryAbnormalNumber();
    },

    confirmHandleData() {
      this.visible = false;
    },

    // 查询异常个数
    queryAbnormalNumber() {
      this.$http({
        url: `/buz/policyRenewalExportResult/getAbnormal`,
        type: "GET",
        data:{
          type:2
        }
      }).then((res) => {
        this.abnormalNumber = res.data;
        this.visible = true;
      })
    },

    // 数据下载
    downloadData(abnormalType) {
      this.$http({
        url: "/buz/policyShortRenewalAbnormalRecord/export",
        type: "POST",
        forced: true,
        responseType: "blob",
        All: true,
        data: {abnormalType},
      }).then(res=>{
        this.$units.daochu(res);
      })
    },

    // 更新/放弃异常数据
    updateAndgiveUp(handleType) {
      this.$http({
        url: "/buz/policyShortRenewalAbnormalRecord/handle",
        type: "POST",
        data:{
          handleType
        },
        apiPermissionCode:'renewalManage_01_3'
      }).then((res) => {
        this.$Message.success("提交成功");
        this.getInsureList();
        this.visible = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.update-abnormal {
  padding: 10px 0px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: #272933;
  }
  .num {
    padding: 2px;
    color: #236dff;
  }
  .tips {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    line-height: 40px;
    font-size: 15px;
     color: #3C464F;
    a {
        padding:0 10px 0 5px ;
    }
    .sign {       
        font-weight: bold;
    }
  }
}
.action-buttom {
  margin-top: 20px;
  padding-bottom: 5px;
  display: flex;
  justify-content: space-between;
  padding:0px  40px 10px 40px;
  Button {
    width: 140px;
    height: 36px;
  }
  .cancel {
    border-color: #236dff;
    color: #236dff;
  }
}
</style>